import type { IPropertyDetailsResponse } from "@/src-refactor/modules/store/qrtk/services/realestate/responses/property-details.response";

export interface IPropertyDetailAlterestate {
  isPublished: boolean;
  isSync: boolean;
  commission: number;
  isFailed: string | null;
}

export const prepareDetailPropertyAlterestate = (
  data: IPropertyDetailsResponse
): IPropertyDetailAlterestate => {
  return {
    isPublished: data.is_alterestate_published,
    isSync: data.is_alterestate_sync,
    commission: data.alterestate_commission,
    isFailed: data.alterestate_failed_sync
  };
};
